import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import MySegmented from "../../components/segmented/Segmented.jsx";
import columns from "../../columns/reports/filesReport.js";
import { GetFileReportApi } from "../../api/request/report.js";
import SkeletonTable from "../../components/table/SkeletonTable.jsx";

const FilesReport = () => {
  const { state } = useLocation();
  const [segmentedValue, setSegmentedValue] = useState(
    state?.status || "unsubmitted"
  );
  const [fileList, setFileList] = useState([]);
  const [total, setTotal] = useState(0);
  const [count, setCount] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const fileStatus = [
    { label: `Unsubmitted (${count?.unsubmitted_count || 0})`, value: "unsubmitted" },
    { label: `Inprocess (${count?.inprocess_count || 0})`, value: "inprocess" },
    { label: `Closed (${count?.closed_count || 0})`, value: "closed" },
  ];

  const getFileList = async (page = 1) => {
    try {
      setIsLoading(true);
      const params = { page, file_status: segmentedValue };
      const { data } = await GetFileReportApi(params);
      if (data?.status) {
        setFileList(
          data?.data?.map((item) => {
            return {
              ...item,
              name: item?.user?.name,
              email: item?.user?.email,
              file: (
                <div className="font-bold highlight-text capitalize">
                  {item?.service_name_slug}
                </div>
              ),
              startDate: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "",
              status: (
                <p className="text-green-500 font-bold uppercase">
                  {item?.status}
                </p>
              ),
            };
          })
        );
        setTotal(data?.total_record);
        setCount(data?.count);
        setCurrentPage(page);
      }
      setIsLoading(false);
    } catch (error) {
      setFileList([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getFileList();
  }, [segmentedValue]);

  const handleTableChange = (pagination) => {
    getFileList(pagination?.current);
  };

  return (
    <div className="border rounded-md bg-white">
      <div className="flex flex-col gap-4">
        <MySegmented
          options={fileStatus}
          value={segmentedValue}
          setValue={setSegmentedValue}
        />

        <div className="table-radius-0 text-light mb-4">
          <SkeletonTable
            columns={columns}
            data={fileList}
            isLoading={isLoading}
            searchingFields={["name", "email", "file_number"]}
            pagination={{
              current: currentPage,
              total: total,
              pageSize: 10,
              showSizeChanger: false,
            }}
            handleTableChange={handleTableChange}
          />
        </div>
      </div>
    </div>
  );
};

export default FilesReport;
